import { Info, ChevronDown } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/Dialog";
import { cn } from "@/util/cn";

type PaymentTermsDialogProps = {
  triggerClassName?: string;
  showChevron?: boolean;
};

export default function PaymentTermsDialog({
  triggerClassName,
  showChevron = false,
}: PaymentTermsDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className={cn(
            "flex items-center gap-1.5 text-gray-400 hover:text-white transition-colors cursor-pointer p-1 rounded-md hover:bg-zinc-800/60",
            triggerClassName
          )}
          aria-label="View refund policy"
        >
          <Info className="w-5 h-5 text-gray-400 hover:text-white" />
          {showChevron && (
            <ChevronDown className="w-4 h-4 text-gray-400 hover:text-white" />
          )}
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto bg-[#181C24] text-white border border-zinc-800 rounded-xl p-6 sm:p-7 shadow-2xl">
        <DialogHeader>
          <DialogTitle className="text-xl sm:text-2xl font-bold text-white tracking-tight">
            Refund policy
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm sm:text-base text-gray-300 leading-relaxed pt-3">
          <p>
            At SolarCloud, we believe in providing our customers with a hassle-free and transparent experience when investing in solar energy.
          </p>
          <p>
            At SolarCloud, your satisfaction is our priority, and our refund policy reflects our commitment to delivering on our promises.
          </p>

          <div className="pt-2">
            <h4 className="font-bold text-white text-base sm:text-lg mb-1">
              Lifetime &apos;deposit&apos; refund policy
            </h4>
            <p className="text-gray-300 text-sm sm:text-base">
              Prior to the fulfilment of your order, you may request a cancellation at any time and for any reason. We will refund your entire deposit amount, no questions asked.
            </p>
          </div>

          <div className="pt-2">
            <h4 className="font-bold text-white text-base sm:text-lg mb-1">
              10 day cooling off
            </h4>
            <p className="text-gray-300 text-sm sm:text-base">
              After placing your deposit, you have a mandatory 10-day cooling-off period during which time you can cancel your order and receive a full refund, no questions asked. This period allows you to take time to review your decision without pressure.
            </p>
          </div>

          <div className="pt-2">
            <h4 className="font-bold text-white text-base sm:text-lg mb-1">
              Change of ownership
            </h4>
            <p className="text-gray-300 text-sm sm:text-base">
              For any reason should you wish to change the owners of your SolarCloud solar you can do so. This can be done by email request and a one time transfer cost of only $75.
            </p>
          </div>

          <div className="pt-2">
            <h4 className="font-bold text-white text-base sm:text-lg mb-1">
              Buy back (technically a transfer)
            </h4>
            <p className="text-gray-300 text-sm sm:text-base">
              Should you for any reason want us to buy back your solar, we are happy to do so as long as we have a customer on the waiting list at that time who wants to buy the remaining balance of your solar warranty period. For example, you bought solar with a 25 year warranty and have had them for 3 years and therefore we will offer a 22 year warranty on them. If we are not able to complete the buy-back at the time of your request we will place you on the buy back list and notify you when available.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
